import { useState } from "react";
import { SignSelectorContainer } from "./style";
import { mapSign } from "@/helpers/getCompatibilityBetweenSigns";
import ContentIcon from "@/shared/ContentIcon";

const SignSelector = () => {
  const [firstSignSelected, setFirstSignSelected] = useState(null);
  const [secondSignSelected, setSecondSignSelected] = useState(null);

  const signsList = [
    ["aries", "tauro", "geminis", "cancer", "leo", "virgo"],
    ["libra", "escorpio", "sagitario", "capricornio", "acuario", "piscis"],
  ];

  const normalizeSign = (sign) =>
    sign
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "");

  const renderSignList = (onClickHandler) =>
    signsList.map((signRow, rowIndex) => (
      <ul key={rowIndex} className="sign-selector-list">
        {signRow.map((sign) => (
          <li key={sign} onClick={() => onClickHandler(sign)}>
            {mapSign[sign].toUpperCase()}
          </li>
        ))}
      </ul>
    ));

  const isSelectingDone = firstSignSelected && secondSignSelected;

  function resetSignSelected() {
    setFirstSignSelected(null);
    setSecondSignSelected(null);
  }

  return (
    <SignSelectorContainer>
      <div className="selection-container">
        <div className="sign-selector-box">
          <div className="selection-content-container">
            <div className="sign-selector-lists">
              {renderSignList(
                !firstSignSelected
                  ? setFirstSignSelected
                  : setSecondSignSelected
              )}
            </div>
            <div className="sign-selector-signs">
              <div className="sign-container">
                <div className="circle red-circle">
                  {firstSignSelected ? (
                    <img
                      width="106px"
                      height="106px"
                      loading="lazy"
                      alt={firstSignSelected}
                      src={`/img/westernastrology/${firstSignSelected}.svg`}
                    />
                  ) : (
                    <p>ESCOGE TU SIGNO</p>
                  )}
                </div>
                {firstSignSelected && (
                  <span className="sign-name">
                    {mapSign[firstSignSelected].toUpperCase()}
                  </span>
                )}
              </div>

              <span className="plus">
                <ContentIcon
                  width="59px"
                  height="59px"
                  nameIcon="plus"
                  fill="#555"
                />
              </span>

              <div
                className={`sign-container ${
                  isSelectingDone ? "" : "is-selecting"
                }`}
              >
                <div
                  className={`circle ${firstSignSelected ? "red-circle" : ""}`}
                  onClick={() =>
                    firstSignSelected && setSecondSignSelected(null)
                  }
                >
                  {secondSignSelected ? (
                    <img
                      width="106px"
                      height="106px"
                      loading="lazy"
                      alt={secondSignSelected}
                      src={`/img/westernastrology/${secondSignSelected}.svg`}
                    />
                  ) : (
                    <p>ESCOGE OTRO SIGNO</p>
                  )}
                </div>
                {secondSignSelected && (
                  <span className="sign-name">
                    {mapSign[secondSignSelected].toUpperCase()}
                  </span>
                )}
              </div>
            </div>
          </div>

          <button
            className={`sign-selector-button ${
              !firstSignSelected || !secondSignSelected
                ? "disabled-btn"
                : "active"
            }`}
            disabled={!firstSignSelected || !secondSignSelected}
            aria-disabled={!firstSignSelected || !secondSignSelected}
            tabIndex={!firstSignSelected || !secondSignSelected ? -1 : 0}
            onClick={() => {
              if (firstSignSelected && secondSignSelected) {
                window.location.href = `/horoscopo/compatibilidad-signos-zodiaco/${normalizeSign(
                  firstSignSelected
                )}-${normalizeSign(secondSignSelected)}`;
              }
            }}
          >
            VER COMPATIBILIDAD
          </button>

          <button className="sign-selector-reset" onClick={resetSignSelected}>
            <div className="sign-selector-reset-content">
              <ContentIcon
                width="20px"
                height="20px"
                nameIcon="reset"
                fill="#555"
              />
              <p className="sign-selector-reset-tooltip">
                Volver a seleccionar
              </p>
            </div>
          </button>
        </div>
      </div>
    </SignSelectorContainer>
  );
};

export default SignSelector;
